/**
 * Of we de webcam zelf moeten tonen in plaats van de camera-app van het
 * toestel.
 *
 * Op een telefoon is die app beter dan wat wij kunnen bouwen: scherpstellen,
 * flits, wisselen tussen voor en achter. Daar laat `capture` op een
 * `<input type="file">` zijn werk doen. Op een machine met een muis negeert de
 * browser `capture` en krijg je de bestandskiezer — precies wat "webcam
 * gebruiken" níet hoort te doen.
 */
export function prefersWebcamSheet(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    navigator.mediaDevices?.getUserMedia !== undefined &&
    window.matchMedia('(pointer: fine)').matches
  )
}
